import { Component, OnInit, Input } from '@angular/core';
import { Building, Company, ProjectService, ProjectBuilding, Partecipant } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, Page } from 'elbuild-ui-lib-core'; import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-project-building-add',
	templateUrl: './project-building-add.component.html',
	styleUrls: ['./project-building-add.component.scss']
})
export class ProjectBuildingAddComponent implements OnInit {

	@Input()
	projectid: number;

	associablerows: Building[] = [];
	allassociablerows: Building[] = [];

	associaterows: ProjectBuilding[] = [];
	allassociaterows: ProjectBuilding[] = [];

	associableloading = true;
	associateloading = true;

	partecipants: Partecipant[];
	@Input()
	companyid: number;

	@Input()
	singlecompany: boolean;

	advancedSearch = new Search('projectbuilding join building on projectbuilding.buildingid = building.id');


	constructor(
		private projectService: ProjectService,
		private activeModal: NgbActiveModal,
		private crudService: CrudService<ProjectBuilding>,
		private partecipantService: CrudService<Partecipant>,
		private messageService: MessageService,
		private translateService: TranslateService
	) { }

	ngOnInit() {
		const search = new Search('partecipant');
		search.addSimpleFilter('entity', 'company');
		this.partecipantService.searchEntities(Partecipant, 'partecipant', search, search.page).subscribe((data: Partecipant[]) => {
			this.partecipants = data;
		});
	}

	loadAssociableBuildings(): void {
		this.associableloading = true;
		this.projectService.getAssociableBuildings(this.projectid, +this.companyid).subscribe((data: Building[]) => {
			this.associablerows = data;
			this.allassociablerows = data;
			this.associableloading = false;
		});
	}

	loadAssociateBuildings(): void {
		this.associateloading = true;
		this.associaterows = [];

		if (this.projectid) {
			this.advancedSearch.addSimpleFilter('projectbuilding.projectid', this.projectid);
		}

		if (+this.companyid) {
			this.advancedSearch.addSimpleFilter('building.companyid', this.companyid);
		} else {
			this.advancedSearch.removeSimpleFilter('building.companyid');
		}

		this.crudService.searchEntities(ProjectBuilding, 'projectbuilding', this.advancedSearch, new Page(1000)).subscribe((data: ProjectBuilding[]) => {
			this.associaterows = data;
			this.allassociaterows = data;
			this.associateloading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.associateloading = false;
		});
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}

	add(building: Building): void {

		const projectbuilding = new ProjectBuilding();
		projectbuilding.projectid = this.projectid;
		projectbuilding.buildingid = building.id;

		this.crudService.createEntity(ProjectBuilding, 'projectbuilding', projectbuilding).subscribe((res) => {
			this.messageService.sendSuccess(
				this.translateService.instant('labels.building-add-success'),
				this.translateService.instant('labels.success')
			);
			this.loadAssociableBuildings();
			this.loadAssociateBuildings();
		}, ({ error }) => {
			this.messageService.sendError(
				error.msg ? error.msg : error,
				this.translateService.instant('labels.event-save-error')
			);
		});
	}

	remove(projectbuilding: ProjectBuilding): void {


		this.crudService.deleteEntity(ProjectBuilding, 'projectbuilding', projectbuilding).subscribe((res) => {
			this.messageService.sendSuccess(
				this.translateService.instant('labels.building-remove-success'),
				this.translateService.instant('labels.success')
			);
			this.loadAssociableBuildings();
			this.loadAssociateBuildings();
		}, ({ error }) => {
			this.messageService.sendError(
				error.msg ? error.msg : error,
				this.translateService.instant('labels.event-save-error')
			);
		});
	}

	updateFilter(event): void {
		const val = event.target.value.toLowerCase();

		if (val) {
			this.associablerows = this.allassociablerows.filter(e => {
				return e.name?.toLowerCase().indexOf(val) >= 0;
			});
			this.associaterows = this.allassociaterows.filter(e => {
				return e.name?.toLowerCase().indexOf(val) >= 0;
			});

		} else {
			this.associablerows = this.allassociablerows.filter(building => true);
			this.associaterows = this.allassociaterows.filter(building => true);
		}
	}

	reloadbuildings(): void {
		this.loadAssociableBuildings();
		this.loadAssociateBuildings();
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.loadAssociateBuildings();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.loadAssociateBuildings();
	}

}
